import { useTranslation } from 'react-i18next';

import { BrandMediaLibrary } from '@/features/brand-media-library';
import { PageTransition } from '@/shared/ui/animations';
import {
  ListPageLayout,
  PageHeader,
  PageHeaderBreadcrumb,
  PageHeaderBreadcrumbLink,
  PageHeaderBreadcrumbPage,
  PageHeaderIdentity,
} from '@/shared/ui/layout';
import { ROUTES } from '@/shared/config/routes';

/**
 * The library on its own, under the Knowledge Hub.
 *
 * A thin host on purpose. Where this belongs is not settled -- a workspace hub, a project library
 * and a brief each have a claim -- so the page supplies no scope at all and the view answers for the
 * whole workspace. Moving it later is a matter of mounting the same feature somewhere else with a
 * scope passed in, not of rebuilding it.
 *
 * The header is a breadcrumb rather than an icon, a title and a description: where you are is the
 * one thing it has to say, and the trail says it while also being the way back, so the separate
 * back button it replaces has nothing left to do. The library supplies its own body surface, so
 * there is no `ListPageBody` around it.
 */
export const BrandMediaLibraryPage = () => {
  const { t } = useTranslation('tools');

  return (
    <ListPageLayout>
      <PageTransition variant="slideUp" delay={0.0}>
        <PageHeader>
          <PageHeaderIdentity>
            <PageHeaderBreadcrumb>
              <PageHeaderBreadcrumbLink href={ROUTES.KNOWLEDGE_HUB}>
                {t('brandMedia.knowledge')}
              </PageHeaderBreadcrumbLink>
              <PageHeaderBreadcrumbPage>{t('brandMedia.title')}</PageHeaderBreadcrumbPage>
            </PageHeaderBreadcrumb>
          </PageHeaderIdentity>
        </PageHeader>
      </PageTransition>

      <PageTransition variant="slideUp" delay={0.1} className="flex min-h-0 flex-1 flex-col">
        <BrandMediaLibrary />
      </PageTransition>
    </ListPageLayout>
  );
};
